// Plan lifecycle: Draft, Proposed, Approved, Active, Adjusted, Closed.
// Expanded in Phase 2 task 2.1 (unified plan screen).

export const planCopy = {
  // State labels (short, for chips and headers)
  stateDraft: 'Draft',
  stateProposed: 'Awaiting approval',
  stateApproved: 'Approved',
  stateActive: 'Active',
  stateAdjusted: 'Adjusted',
  stateClosed: 'Closed',

  // Headline explanations for each state (shown once per status as context)
  explainDraft: 'This plan has not been sent to the executive yet.',
  explainProposed: 'The plan is ready for review. Approve to lock it in or replan to try again.',
  explainApproved: 'The plan is approved. Activate it when the day begins.',
  explainActive: 'The plan is live. Mark items complete as the day progresses.',
  explainAdjusted: 'The plan was updated mid-day. The active work has been re-scheduled.',
  explainClosed: 'The day is closed. Carry-forward items are already queued for tomorrow.',

  // EA actions on Proposed / Draft
  sendForApproval: 'Send plan to executive for approval',

  // Executive actions on Proposed
  approvePlan: "Approve today's plan",
  // Pre-activation "Replan" — the button calls rhythmApi.replan which
  // regenerates the plan via Start-My-Day. "Adjust plan" used to be the
  // label but read as "open an editor" when the action is actually
  // "re-run the planner"; rename closed the mismatch (2026-06-01).
  adjustPlan: 'Replan',
  rejectPlan: 'Reject plan',

  // Approved state
  activatePlan: 'Activate plan',

  // Active state
  completeItem: 'Mark complete',
  reopenItem: 'Reopen',
  replanMidDay: 'Replan the rest of today',

  // Close of day
  closeDayHeading: 'Close the day',
  closeDayAction: 'Close the day',
  closeDayPromptWorked: 'What worked today',
  closeDayPromptSlipped: 'What slipped',
  closeDayPromptTomorrow: 'What changes tomorrow',

  // Empty / pre-start state (§6 empty-state pattern)
  noPlanHeading: 'No plan for today yet',
  noPlanBody:
    'Start my day pulls your calendar, unfinished work, and strategic drivers into one ordered plan. It protects focus time, flags risk, and gives you the single next action to take.',
  startMyDay: 'Start my day',

  // Progress strip labels
  progressCompleted: 'Completed',
  progressRemaining: 'Remaining',
  progressOnTrack: 'On track',
  progressBehind: 'Behind plan',
  progressAhead: 'Ahead of plan',

  // Common labels
  dailyThemeLabel: 'Daily theme',
  aiBriefingLabel: 'AI briefing',
  risksLabel: 'Risks',
  handoffNotesLabel: 'Handoff notes from your EA',
  preparedByLabel: 'Prepared by',
  approvedByLabel: 'Approved by',
} as const;
